import React, { useCallback, useRef } from 'react';

import { MOBILE_BREAK_POINT } from 'app/constants';
import useIsMobile from 'hooks/use-is-mobile';
import { useConfigs } from 'modules/configs';
import SignInButton from 'pages/Landings/components/SignInButton';
import SupportButton from 'pages/Landings/components/SupportButton';

import useStyles from './styles';

import { useIsScrolled } from '../../hooks/use-is-scrolled';
import BookDemoButton from '../BookDemoButton';
import DrawerMenu from '../DrawerMenu';
import Logo from '../Logo';
import TopMenu from '../TopMenu';

interface Props {
    blurry?: boolean;
    className?: string;
}

const Header: React.FC<Props> = ({ className, blurry = false }) => {
    const { classes, cx } = useStyles();
    const { entrypoint } = useConfigs();
    const containerRef = useRef<HTMLDivElement | null>(null);
    const self = useCallback(() => containerRef.current!, []);
    const parent = useCallback(() => self().parentElement!, [self]);

    const [isDrawerScrolled, drawerScrollerRef] = useIsScrolled();
    const isMobile = useIsMobile(MOBILE_BREAK_POINT);

    return (
        <>
            <div
                className={cx(classes.root, className, {
                    [classes._blurry]: blurry || isDrawerScrolled,
                    [classes._gutterless]: isMobile
                })}
                ref={containerRef}
            >
                <Logo />
                {isMobile ? (
                    <DrawerMenu container={parent} scroller={drawerScrollerRef} />
                ) : (
                    <>
                        <TopMenu container={self} />
                        <div className={classes.buttons}>
                            {entrypoint === 'main' && <SignInButton />}
                            {entrypoint === 'main' && <BookDemoButton color="black" size="small" />}
                            {entrypoint === 'docs' && <SupportButton size="small" />}
                        </div>
                    </>
                )}
            </div>
        </>
    );
};

export default Header;
